import axios from "axios";
import moment from "moment";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const api = axios.create({
  baseURL: BASE_URL,
});

export const imageUpload = async (file) => {
  try {
    let imageFile = file;
    if (imageFile && imageFile instanceof File) {
      const newImageName = `${moment().format("YYYYMMDDHHmmssSSS")}_${
        imageFile.name
      }`;
      imageFile = new File([imageFile], newImageName, {
        type: imageFile.type,
      });

      const {
        data: { uploadUrl },
      } = await api.post("/getUploadLink", {
        metadata: {
          fileName: imageFile.name,
          contentType: imageFile.type,
        },
        type: "images",
      });

      let formData = new FormData();
      formData.append("file", imageFile);

      const res = await fetch(uploadUrl, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        throw new Error("File upload failed");
      }

      const resData = await res.json();

      const publicImageUrl = resData.result.variants.find((url) =>
        url.includes("/public")
      );

      if (!publicImageUrl) {
        throw new Error("Public image URL not found");
      }

      return publicImageUrl;
    }
  } catch (error) {
    console.error("An error occurred while uploading the image:", error);
    return { error: error.message, publicImageUrl: null };
  }
};

export const documentUpload = async (file) => {
  try {
    if (file && file instanceof File) {
      const sanitizedFileName = file.name.replace(/\s+/g, "_");
      const newDocumentName = `${moment().format(
        "YYYYMMDDHHmmssSSS"
      )}_${sanitizedFileName}`;

      const renamedFile = new File([file], newDocumentName, {
        type: file.type,
      });

      // Get pre-signed URLs from the server
      const {
        data: { uploadUrl, publicUrl },
      } = await api.post("/getUploadLink", {
        metadata: {
          fileName: renamedFile.name,
          contentType: renamedFile.type,
        },
        type: "documents",
      });

      // Upload the file using PUT
      const res = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          "Content-Type": renamedFile.type,
        },
        body: renamedFile,
      });

      if (!res.ok) {
        throw new Error("File upload failed");
      }

      return {
        publicUrl,
        newDocumentName,
      }; // Return the public URL and new document name
    }
  } catch (error) {
    console.error("Error uploading document:", error.message);
    throw error;
  }
};

export const fileDelete = async (fileKey, type) => {
  try {
    const response = await api.delete("/getUploadLink/delete", {
      data: {
        fileKey,
        type,
      },
    });

    // Check if the status is 200 to determine success
    if (response.status === 200) {
      console.log("File deleted successfully:", response.data.message);
      return { success: true, message: response.data.message };
    } else {
      throw new Error(response.data.error || "Failed to delete file");
    }
  } catch (error) {
    console.error("An error occurred while deleting the file:", error);
    return { error: error.message, success: false };
  }
};
